import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { voucherSchema } from '../types';

export type EditVoucherMutationParams = {
	id: number;
	deposit: number;
	wagering: number;
	isLocked: boolean;
};

export const createEditVoucherMutation = () =>
	createAuthMutation({
		params: declareParams<EditVoucherMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `/voucher/${id}`,
			body: ({ deposit, wagering, isLocked }) => ({
				deposit,
				wagering,
				isLocked,
			}),
		},
		response: {
			contract: zodContract(voucherSchema),
		},
	});
